export default "__VITE_ASSET__BgWlI26N__"